export default "__VITE_ASSET__2c00e32b__"